import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import styled from "styled-components";
import { getGalleryImagesByCategory } from "./galleryApi";

function GalleryWiseImages() {
  const { categoryId } = useParams();
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    getGalleryImagesByCategory(categoryId)
      .then((res) => setImages(res.data.data))
      .catch((err) => console.log(err));
  }, [categoryId]);

  // ESC key close modal
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setSelectedImage(null);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <Wrapper>
      <div className="container">
        {/* ✅ SAME TITLE STYLE */}
        <h2 className="text-center mb-4 maintext">GALLERY IMAGES</h2>

        <div
          className="underline mx-auto"
          style={{
            height: 3,
            width: "4rem",
            backgroundColor: "#34495E",
            marginTop: 20,
            marginBottom: 20,
          }}
        ></div>

        {/* ✅ SAME GRID */}
        <div className="row">
          {images.map((img) => (
            <div key={img.id} className="col-md-4 mb-4">
              <div
                className="image-container"
                onClick={() =>
                  setSelectedImage(
                    `https://ayushiconstruction.com/public/uploads/${img.image_url}`,
                  )
                }
              >
                <img
                  src={`https://ayushiconstruction.com/public/uploads/${img.image_url}`}
                  className="thumbnail"
                  alt="gallery"
                />
              </div>
            </div>
          ))}
        </div>

        {/* ✅ BACK BUTTON */}
        <div className="text-center mt-4 mb-5">
          <Link to="/gallery" className="btn btn-secondary">
            Back to Projects Gallery Page
          </Link>
        </div>
      </div>

      {/* ✅ SAME MODAL */}
      {selectedImage && (
        <div className="modal" onClick={() => setSelectedImage(null)}>
          <img src={selectedImage} alt="Full View" className="modal-image" />
        </div>
      )}
    </Wrapper>
  );
}

export default GalleryWiseImages;

const Wrapper = styled.div`
  .container {
    margin-top: 8rem;

    @media screen and (max-width: 768px) {
      margin-top: 6rem;
    }
  }

  .maintext {
    color: #f26a20;
  }

  .image-container {
    cursor: pointer;
  }

  .thumbnail {
    width: 100%;
    height: 220px;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  .thumbnail:hover {
    transform: scale(1.05);
  }

  /* Modal */
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    cursor: pointer;
  }

  .modal-image {
    max-width: 90%;
    max-height: 90%;
    border: 2px solid white;
  }
`;
